export default __webpack_public_path__ + "static/media/Slider-02.fe4cd102.jpg";